<template>
    <div class="block-trending__feed d-flex flex-wrap">
        <a
            v-for="post in posts"
            :key="post.id"
            v-lazy:background-image="post.image"
            :href="post.full_url"
            :name="post.unformatted_message"
            class="block-trending__image"
        >
        </a>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    props: {
        apiUrl: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            posts: []
        };
    },

    created() {
        this.getJuicerFeed();
    },

    methods: {
        getJuicerFeed() {
            Axios.get(this.apiUrl + '?per=9')
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }

                    this.posts = response.data.posts.items;
                    return true;
                })
                .catch(() => false);
        }
    }
};
</script>

<style lang="scss" scoped>
.block-trending__image {
    width: calc(33.333% - 6px);
    padding-top: calc(33.333% - 6px);
    margin: 3px;
    background-size: cover;

    @include media-breakpoint-up(lg) {
        width: calc(33.333% - 10px);
        padding-top: calc(33.333% - 10px);
        margin: 5px;
    }
}
</style>
